import { render, staticRenderFns } from "./report.vue?vue&type=template&id=67af082e&scoped=true&"
import script from "./report.vue?vue&type=script&lang=js&"
export * from "./report.vue?vue&type=script&lang=js&"
import style0 from "./report.vue?vue&type=style&index=0&id=67af082e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af082e",
  null
  
)

export default component.exports